// NOTE: sensitive to barrel imports! Use deep imports!
import { getDiff } from '../utils';
import { EExecutor } from '../access/executor.enum';
/**
 * Needs injection factory providing platform specific AccessServiceProvider!
 * Use FrontendRestraintsFactory / BackendRestraintsFactory to create instances!
 */
export class ItemRestraints {
  get access() {
    const tmp = this.accessProvider.get();
    if (!tmp) console.error('could not get AccessService', tmp, this.accessProvider);
    return tmp;
  }
  constructor(accessProvider, executorProvider) {
    this.accessProvider = accessProvider;
    this.executorProvider = executorProvider;
    if (!accessProvider) throw new Error('ItemRestraints created without passing accessProvider');
  }
  canViewItem(item) {
    return true;
  }
  canCreateItem(item) {
    return true;
  }
  canUpdateItem(item, oldItem) {
    return true;
  }
  canToggleItem(item, oldItem) {
    return true;
  }
  canRemoveItem(item) {
    return true;
  }
  // ########  HELPER METHODS  ################################################################
  getDiff(newItem, oldItem) {
    return getDiff(oldItem, newItem);
  }
  requireRole(role, then, reject) {
    const passed = this.hasRole(role);
    if (!passed) {
      if (reject) return reject();
      return "Sie haben nicht die Berechtigung, diesen Vorgang auszuführen.";
    } else {
      if (then) return then();
      return true;
    }
  }
  hasRole(role) {
    if (!this.access) return false;
    return this.access.hasRole(role);
  }
  currentUserIsOwner(item) {
    if (!this.access) throw new Error("Prüfung des Besitzers fehlgeschlagen: AccessService nicht verfügbar");
    // ownerId===null is allowed, so check against undefined!
    if (typeof item.ownerId === 'undefined') throw new Error("Prüfung des Besitzers fehlgeschlagen: Item hat keine Angabe für ownerId");
    const userId = this.access.getAccessData('userId', null, 'null');
    if (!this.access.isLoggedIn || !userId) return false;
    if (userId === item.ownerId) return true;
    return false;
  }
  isExecutedBySystem() {
    return this.executorProvider.get() === EExecutor.system;
  }
}
export class AdminOnlyItemRestraints extends ItemRestraints {
  canCreateItem(item) {
    return this.isExecutedBySystem() || this.requireRole('ADMINISTRATOR');
  }
  canViewItem(item) {
    return this.isExecutedBySystem() || this.requireRole('ADMINISTRATOR');
  }
  canToggleItem(item) {
    return this.isExecutedBySystem() || this.requireRole('ADMINISTRATOR');
  }
  canUpdateItem(item, oldItem) {
    return this.isExecutedBySystem() || this.requireRole('ADMINISTRATOR');
  }
  canRemoveItem(item) {
    return this.isExecutedBySystem() || this.requireRole('ADMINISTRATOR');
  }
}
export class ReadonlyItemRestraints extends ItemRestraints {
  canToggleItem(item) {
    return 'Not toggleable';
  }
  canUpdateItem(item, oldItem) {
    return 'Not updateable';
  }
  canRemoveItem(item) {
    return 'Not removable';
  }
}